module.exports = __webpack_public_path__ + "img/whoarewe3.09ab58b4.png";